import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingModal from "./components/UI/LoadingModal";
import AppLayout from "./containers/AppLayout";
import Routes from "./Routes";
import { persistLoggedUser, selectUser } from "./store/userSlice";

const App = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  useEffect(() => {
    dispatch(persistLoggedUser());
  }, [dispatch]);

  return user.isValidating ? (
    <LoadingModal />
  ) : (
    <AppLayout>
      <Routes />
    </AppLayout>
  );
};

export default App;
